(function() {
  try {
    var pid = Number(document.querySelector('.product-page').dataset.productId);
    var cached = JSON.parse(sessionStorage.getItem('pokemon_at_show') || 'null');
    var version = sessionStorage.getItem('pokemon_cache_version');
    if (cached && cached.cache_version === version && Array.isArray(cached.product_ids)) {
      if (cached.product_ids.map(String).indexOf(String(pid)) !== -1) {
        document.documentElement.classList.add('product-has-at-show');
        document.documentElement.dataset.atShowName = cached.name || '';
        document.documentElement.dataset.atShowHandle = cached.handle || '';
        document.documentElement.dataset.atShowSelectionMode = cached.selection_mode || 'products';
        document.documentElement.dataset.atShowVariantIds = JSON.stringify(cached.variant_ids || []);
        if ((cached.fully_at_show_product_ids || cached.product_ids || []).map(String).indexOf(String(pid)) !== -1) {
          document.documentElement.classList.add('product-at-show');
        }
      }
    }
  } catch(e) {}
})();
